// src/packages/viriyah/non-motor/viriyah_cargo_inland_020/CargoInlandDetails.jsx
import React, { useState } from "react";
import "./cargo_inland.css";

/**
 * Viriyah – Inland Transit (020)
 * โครงสร้างรายละเอียดแบบขายลูกค้า: ครอบคลุม/ข้อยกเว้น/วิธีทำประกัน/ตารางเบี้ย (ตัวอย่าง กลุ่ม 1)
 * อ้างอิง: คู่มือกรมธรรม์ + ตารางเบี้ยของบริษัท
 */
export default function CargoInlandDetails({ onQuote }) {
  // ====== ตารางเบี้ยตัวอย่าง (กลุ่มสินค้า 1) ======
  const rowsGroup1 = [
    { sumInsured: "100,000",  namedNet: "2,250",  namedGross: "2,417.13", allRiskNet: "2,500",  allRiskGross: "2,685.70" },
    { sumInsured: "200,000",  namedNet: "4,200",  namedGross: "4,512.19", allRiskNet: "4,800",  allRiskGross: "5,157.40" },
    { sumInsured: "300,000",  namedNet: "5,200",  namedGross: "5,586.47", allRiskNet: "5,400",  allRiskGross: "5,801.54" },
    { sumInsured: "400,000",  namedNet: "6,200",  namedGross: "6,660.75", allRiskNet: "6,800",  allRiskGross: "7,305.96" },
    { sumInsured: "500,000",  namedNet: "7,200",  namedGross: "7,735.03", allRiskNet: "7,800",  allRiskGross: "8,380.24" },
    { sumInsured: "600,000",  namedNet: "7,900",  namedGross: "8,487.24", allRiskNet: "8,600",  allRiskGross: "9,239.45" },
    { sumInsured: "700,000",  namedNet: "8,600",  namedGross: "9,239.45", allRiskNet: "9,400",  allRiskGross: "10,098.66" },
    { sumInsured: "800,000",  namedNet: "9,300",  namedGross: "9,991.66", allRiskNet: "10,200", allRiskGross: "10,957.87" },
    { sumInsured: "900,000",  namedNet: "9,900",  namedGross: "10,635.80",allRiskNet: "11,000", allRiskGross: "11,817.08" },
    { sumInsured: "1,000,000",namedNet: "10,800", namedGross: "11,603.08",allRiskNet: "11,800", allRiskGross: "12,677.36" },
  ];

  const [viewAllRows, setViewAllRows] = useState(false);
  const visibleRows = viewAllRows ? rowsGroup1 : rowsGroup1.slice(0, 5);

  // ====== จุดขาย/ภาพรวมคุ้มครอง ======
  const highlights = [
    "คุ้มครองความเสียหาย/สูญเสียของสินค้าอันเกิดจากเหตุอุบัติเหตุภายนอก",
    "เลือกทำเป็น Voyage Policy (รายเที่ยว) หรือ Time Policy (รายระยะเวลา) ได้",
    "คุ้มครองตั้งแต่ ‘ยกขึ้น’ ถึง ‘ยกลง’ ณ จุดหมาย ตามแบบคุ้มครองที่เลือก",
  ];

  // ====== ช่องทางขนส่งที่รองรับ ======
  const transports = [
    "ทางบก: รถ 4/6/10 ล้อ, หัวลาก/กึ่งพ่วง (แจ้งทะเบียน)",
    "ทางรถไฟ: แจ้งหมายเลขขบวน",
    "ทางน้ำ: แจ้งชื่อเรือและทะเบียน",
    "ทางเครื่องบิน: แจ้งหมายเลขเที่ยวบิน",
  ];

  // ====== แบบคุ้มครอง ======
  const coverTypes = [
    {
      name: "แบบระบุภัย",
      details: [
        "ไฟไหม้/ระเบิด/ฟ้าผ่า",
        "ยานพาหนะประสบอุบัติเหตุ เช่น ชน ตกถนน/สะพาน พลิกคว่ำ",
      ],
      note: "คุ้มครองเฉพาะรายการภัยที่ระบุไว้ชัดเจน",
    },
    {
      name: "แบบเสี่ยงภัยทุกชนิด",
      details: [
        "คุ้มครองเหตุภายนอกกว้างกว่า ‘ระบุภัย’",
        "รวม General Average, Salvage Charges ตามกฎหมาย/ประเพณี",
      ],
      note: "ยกเว้นตามหมวดข้อยกเว้นสำคัญ",
    },
  ];

  // ====== ข้อยกเว้นสำคัญ (สรุป) ======
  const exclusions = [
    "สงคราม/จลาจล/ก่อการร้าย (เว้นแต่ระบุรับรอง)",
    "เมาสุรา/ยาเสพติด หรือการกระทำผิดกฎหมาย",
    "กีฬาความเสี่ยงสูง (หากเงื่อนไขแผนไม่ได้ครอบคลุม)",
    "ของต้องห้าม/ของมีค่าบางรายการที่ไม่เป็นไปตามเงื่อนไขการเก็บรักษา/หลักฐาน",
  ];

  // ====== Deductible (ตัวอย่างตามกลุ่มสินค้า) ======
  const deductibles = [
    { group: "กลุ่ม 1", rule: "10% ของความเสียหาย หรือขั้นต่ำ 5,000 บาท (แล้วแต่จำนวนใดสูงกว่า)" },
    { group: "กลุ่ม 2", rule: "20% ของความเสียหาย หรือขั้นต่ำ 10,000 บาท (แล้วแต่จำนวนใดสูงกว่า)" },
    { group: "กลุ่ม 3", rule: "20% ของความเสียหาย หรือขั้นต่ำ 10,000 บาท (แล้วแต่จำนวนใดสูงกว่า)" },
    { group: "กลุ่ม 4", rule: "20% ของความเสียหาย หรือขั้นต่ำ 20,000 บาท (แล้วแต่จำนวนใดสูงกว่า)" },
  ];

  return (
    <div className="pkg-detail cargo-inland">
      <h2>Inland Transit (020) — วิริยะประกันภัย</h2>
      <p>
        ประกันภัยสินค้าที่ขนส่งภายในประเทศไทย ครอบคลุมตั้งแต่ “ยกขึ้น” เข้าสู่ยานพาหนะจนถึง “ยกลง”
        ณ จุดหมาย รองรับทางบก/เรือ/รถไฟ/เครื่องบิน ทำแบบรายเที่ยวหรือรายระยะเวลา
        {/* อ้างอิง: คู่มือผลิตภัณฑ์ + ตารางเบี้ยของบริษัท */}
      </p>

      <h3 className="pkg-section">จุดขายสำคัญ</h3>
      <ul className="pkg-bullets">
        {highlights.map((t) => <li key={`hi-${t}`}>{t}</li>)}
      </ul>

      <h3 className="pkg-section">ช่องทางขนส่งที่รองรับ</h3>
      <ul className="pkg-bullets">
        {transports.map((t) => <li key={`tr-${t}`}>{t}</li>)}
      </ul>

      <h3 className="pkg-section">แบบคุ้มครอง</h3>
      <div className="pkg-covers">
        {coverTypes.map((c) => (
          <div className="pkg-cover" key={`cov-${c.name}`}>
            <h4>{c.name}</h4>
            <ul>
              {c.details.map((d) => <li key={`covd-${d}`}>{d}</li>)}
            </ul>
            <p className="pkg-note">* {c.note}</p>
          </div>
        ))}
      </div>

      <h3 className="pkg-section">Deductible (สรุปตามกลุ่มสินค้า)</h3>
      <ul className="pkg-bullets">
        {deductibles.map((d) => <li key={`dd-${d.group}`}><strong>{d.group}:</strong> {d.rule}</li>)}
      </ul>

      <h3 className="pkg-section">ตารางเบี้ย (ตัวอย่าง — กลุ่มสินค้า 1)</h3>
      <table className="pkg-table">
        <thead>
          <tr>
            <th>วงเงินเอาประกัน (บาท)</th>
            <th>ระบุภัย (เบี้ยสุทธิ)</th>
            <th>ระบุภัย (เบี้ยรวม)</th>
            <th>เสี่ยงภัยทุกชนิด (เบี้ยสุทธิ)</th>
            <th>เสี่ยงภัยทุกชนิด (เบี้ยรวม)</th>
          </tr>
        </thead>
        <tbody>
          {visibleRows.map((r) => (
            <tr key={`g1-${r.sumInsured}`}>
              <td>{r.sumInsured}</td>
              <td>{r.namedNet}</td>
              <td>{r.namedGross}</td>
              <td>{r.allRiskNet}</td>
              <td>{r.allRiskGross}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="pkg-foot">
        <button className="pkg-small-btn" onClick={() => setViewAllRows(!viewAllRows)}>
          {viewAllRows ? "แสดงน้อยลง" : "ดูเบี้ยเพิ่ม (กลุ่ม 1 ถึง 1,000,000)"}
        </button>
        <p className="pkg-note">
          * เบี้ยและ Deductible สำหรับ “กลุ่ม 2–5” โปรดดูเอกสารตารางเบี้ยฉบับเต็มของบริษัท
        </p>
      </div>

      <h3 className="pkg-section">ขั้นตอนทำประกัน & เคลม (ย่อ)</h3>
      <ol className="pkg-steps">
        <li>กำหนด “กลุ่มสินค้า” และ “แบบคุ้มครอง” (ระบุภัย/เสี่ยงภัยทุกชนิด) และ “ลักษณะการทำ (Voyage/Time)”</li>
        <li>ระบุเส้นทาง/ทะเบียนยานพาหนะ/รายละเอียดเที่ยว (ตามช่องทางขนส่งที่รองรับ)</li>
        <li>เหตุเกิดเคลม: แจ้งบริษัท/โบรกเกอร์ พร้อมหลักฐาน (รายงานอุบัติเหตุ/ภาพถ่าย/ใบแจ้งความ/เอกสารขนส่ง ฯลฯ)</li>
        <li>กรณีซากทรัพย์สินและการพิจารณาสินไหม ให้ปฏิบัติตามแนวทางในคู่มือผลิตภัณฑ์ของบริษัท</li>
      </ol>

      <div className="pkg-foot">
        <p className="pkg-note">
          * โปรดอ่านข้อยกเว้น/เงื่อนไขกรมธรรม์ฉบับเต็มก่อนตัดสินใจซื้อ; ความคุ้มครองเริ่ม–สิ้นสุดตามแบบ Voyage/Time ที่เลือก
        </p>
        <button className="pkg-quote-btn" onClick={onQuote} aria-label="ขอใบเสนอราคา Inland Transit">
          ขอใบเสนอราคา
        </button>
      </div>
    </div>
  );
}
